module.exports = __webpack_public_path__ + "media/images/bg-wave-5fce2a7aac2dacb479a035c0d10e1120.jpg";